var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"landing-section"}},[_c('h1',{attrs:{"id":"deepangio-title"}},[_c('span',{staticClass:"silver-color"},[_vm._v("Deep")]),_vm._v("Angio")]),_c('h2',{attrs:{"id":"one-liner"}},[_vm._v("Coronary angiography using AI assistive technology")])])])
}]

export { render, staticRenderFns }